import Vue from 'vue'
import Router from 'vue-router'
import {
  mRouter
} from './mRouter'
import config from "../../config";

Vue.use(Router)

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

// 页面
const Index = () => import('@/pages/Index')

const Mine = () => import('@/pages/Mine') //个人中心


export default new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production'
    ? config.build.assetsPublicPath
    : config.dev.assetsPublicPath, // 推荐：通过环境变量动态设置
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [
    ...mRouter,
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: {
        keepAlive: false,
        title: 'MRO工业品一站式采购商城平台_畅为中台云',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/Mine',
      name: 'mine',
      component: Mine,
      meta: {
        keepAlive: false,
        title: '个人中心 - 畅为',
        showHead: true,
        isMobile: false
      },
      children: [{
          path: 'account',
          name: 'account',
          component: () => import('@/pages/Account'),
          meta: {
            keepAlive: false,
            title: '账户中心 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineScore',
          name: 'mineScore',
          component: () => import('@/pages/MineScore'),
          meta: {
            keepAlive: false,
            title: '我的积分 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineScoreOrder',
          name: 'mineScoreOrder',
          component: () => import('@/pages/MineScoreOrder'),
          meta: {
            keepAlive: false,
            title: '积分订单 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineScoreOrderDetail',
          name: 'mineScoreOrderDetail',
          component: () => import('@/pages/MineScoreOrderDetail'),
          meta: {
            keepAlive: false,
            title: '积分订单 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineInfo',
          name: 'mineInfo',
          component: () => import('@/pages/MineInfo'),
          meta: {
            keepAlive: false,
            title: '账户中心 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineOrder',
          name: 'mineOrder',
          component: () => import('@/pages/MineOrder'),
          meta: {
            keepAlive: false,
            title: '订单 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineOrderTeam',
          name: 'mineOrderTeam',
          component: () => import('@/pages/MineOrderTeam'),
          meta: {
            keepAlive: false,
            title: '团购订单 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineOrderActive',
          name: 'mineOrderActive',
          component: () => import('@/pages/MineOrderActive'),
          meta: {
            keepAlive: false,
            title: '活动订单 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineTeamOrderDetail',
          name: 'mineTeamOrderDetail',
          component: () => import('@/pages/MineTeamOrderDetail'),
          meta: {
            keepAlive: false,
            title: '团购订单 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineBill',
          name: 'mineBill',
          component: () => import('@/pages/MineBill'),
          meta: {
            keepAlive: false,
            title: '对账单 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        // {
        //   path: 'mineIssue',
        //   name: 'mineIssue',
        //   component: () => import('@/pages/MineIssue'),
        //   meta: {
        //     keepAlive: false,
        //     title: '发布产品 - 畅为',
        //     showHead: true,
        //     isMobile: false
        //   }
        // },
        {
          path: 'mineIssueManage',
          name: 'mineIssueManage',
          component: () => import('@/pages/MineIssueManage'),
          meta: {
            keepAlive: false,
            title: '进销存管理 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineNeed',
          name: 'mineNeed',
          component: () => import('@/pages/MineNeed'),
          meta: {
            keepAlive: false,
            title: '需求登记 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineNeedAdd',
          name: 'mineNeedAdd',
          component: () => import('@/pages/MineNeedAdd'),
          meta: {
            keepAlive: false,
            title: '需求登记 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: '/mineNeedDetail',
          name: 'mineNeedDetail',
          component: () => import('@/pages/MineNeedDetail'),
          meta: {
            keepAlive: false,
            title: '需求登记 - 畅为',
            showHead: true,
            isMobile: false
          },
        },
        {
          path: 'mineCompany',
          name: 'mineCompany',
          component: () => import('@/pages/MineCompany'),
          meta: {
            keepAlive: false,
            title: '申请加入企业 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineEnterprise',
          name: 'mineEnterprise',
          component: () => import('@/pages/MineEnterprise'),
          meta: {
            keepAlive: false,
            title: '企业信息 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineBuyBill',
          name: 'mineBuyBill',
          component: () => import('@/pages/MineBuyBill'),
          meta: {
            keepAlive: false,
            title: '我的采购单 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineCollect',
          name: 'mineCollect',
          component: () => import('@/pages/MineCollect'),
          meta: {
            keepAlive: false,
            title: '收藏夹 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineAddress',
          name: 'mineAddress',
          component: () => import('@/pages/MineAddress'),
          meta: {
            keepAlive: false,
            title: '地址管理 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'minePrice',
          name: 'minePrice',
          component: () => import('@/pages/MinePrice'),
          meta: {
            keepAlive: false,
            title: '价格附录 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineInvoice',
          name: 'mineInvoice',
          component: () => import('@/pages/MineInvoice'),
          meta: {
            keepAlive: false,
            title: '发票管理 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineDeliveryOrder',
          name: 'mineDeliveryOrder',
          component: () => import('@/pages/MineDeliveryOrder'),
          meta: {
            keepAlive: false,
            title: '提货单 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineAccount',
          name: 'mineAccount',
          component: () => import('@/pages/MineAccount'),
          meta: {
            keepAlive: false,
            title: '我的账户 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineDiscount',
          name: 'mineDiscount',
          component: () => import('@/pages/MineDiscount'),
          meta: {
            keepAlive: false,
            title: '我的优惠券 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineContract',
          name: 'mineContract',
          component: () => import('@/pages/MineContract'),
          meta: {
            keepAlive: false,
            title: '协议管理 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineFootprint',
          name: 'mineFootprint',
          component: () => import('@/pages/MineFootprint'),
          meta: {
            keepAlive: false,
            title: '浏览足迹 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineSolution',
          name: 'mineSolution',
          component: () => import('@/pages/MineSolution'),
          meta: {
            keepAlive: false,
            title: '我的解决方案 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineCloudStorage',
          name: 'mineCloudStorage',
          component: () => import('@/pages/MineCloudStorage'),
          meta: {
            keepAlive: false,
            title: '我的云仓 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineCloudStorageDetail',
          name: 'mineCloudStorageDetail',
          component: () => import('@/pages/MineCloudStorageDetail'),
          meta: {
            keepAlive: false,
            title: '云仓详情 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineVipPrivilege',
          name: 'mineVipPrivilege',
          component: () => import('@/pages/MineVipPrivilege'),
          meta: {
            keepAlive: false,
            title: '会员权益 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'mineVipRegister',
          name: 'mineVipRegister',
          component: () => import('@/pages/MineVipRegister'),
          meta: {
            keepAlive: false,
            title: '会员权益 - 畅为',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'supplierGoods',
          name: 'supplierGoods',
          component: () => import('@/pages/SupplierGoods'),
          meta: {
            keepAlive: false,
            title: '供应商合作 - 商品列表',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'supplierGoodsAdd',
          name: 'supplierGoodsAdd',
          component: () => import('@/pages/supplierGoodsAdd'),
          meta: {
            keepAlive: false,
            title: '供应商合作 - 商品添加',
            showHead: true,
            isMobile: false
          }
        },
        {
          path: 'empty',
          name: 'empty',
          component: () => import('@/pages/empty'),
          meta: {
            keepAlive: false,
            title: '供应商合作',
            showHead: true,
            isMobile: false
          }
        },
      ]
    },
    {
      path: '/staff',
      name: 'staff',
      component: () => import('@/pages/Staff'),
      meta: {
        keepAlive: false,
        title: '员工管理 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/staffApply',
      name: 'staffApply',
      component: () => import('@/pages/StaffApply'),
      meta: {
        keepAlive: false,
        title: '申请处理 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/mineCompanySearch',
      name: 'mineCompanySearch',
      component: () => import('@/pages/MineCompanySearch'),
      meta: {
        keepAlive: false,
        title: '搜索公司 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/Login'),
      meta: {
        keepAlive: false,
        title: '登录 - 畅为',
        showHead: false,
        isMobile: false
      }
    },
    {
      path: '/forgotPassword',
      name: 'forgotPassword',
      component: () => import('@/pages/ForgotPassword'),
      meta: {
        keepAlive: false,
        title: '忘记密码 - 畅为',
        showHead: false,
        isMobile: false
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/pages/Register'),
      meta: {
        keepAlive: false,
        title: '注册 - 畅为',
        showHead: false,
        isMobile: false
      }
    },
    {
      path: '/setCompany',
      name: 'setCompany',
      component: () => import('@/pages/SetCompany'),
      meta: {
        keepAlive: false,
        title: '创建公司 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('@/pages/Help'),
      meta: {
        keepAlive: false,
        title: '帮助中心 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('@/pages/News'),
      meta: {
        keepAlive: false,
        title: '消息中心 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/newsList',
      name: 'newsList',
      component: () => import('@/pages/newsList'),
      meta: {
        keepAlive: false,
        title: '消息中心-月政策 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/brand',
      name: 'brand',
      component: () => import('@/pages/Brand'),
      meta: {
        keepAlive: false,
        title: '品牌 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/brandDetail',
      name: 'brandDetail',
      component: () => import('@/pages/BrandDetail'),
      meta: {
        keepAlive: false,
        title: '品牌详情 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/information',
      name: 'information',
      component: () => import('@/pages/Information'),
      meta: {
        keepAlive: false,
        title: '资讯 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/informationList',
      name: 'informationList',
      component: () => import('@/pages/InformationList'),
      meta: {
        keepAlive: false,
        title: '资讯 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/informationTip',
      name: 'informationTip',
      component: () => import('@/pages/InformationTip'),
      meta: {
        keepAlive: false,
        title: '资讯 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/informationDetail',
      name: 'informationDetail',
      component: () => import('@/pages/InformationDetail'),
      meta: {
        keepAlive: false,
        title: '资讯详情 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/industry',
      name: 'industry',
      component: () => import('@/pages/Industry'),
      meta: {
        keepAlive: false,
        title: '行业解决方案 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/scoreShop',
      name: 'scoreShop',
      component: () => import('@/pages/ScoreShop'),
      meta: {
        keepAlive: false,
        title: '积分商城 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/integralMall',
      name: 'integralMall',
      component: () => import('@/pages/integralMall'),
      meta: {
        keepAlive: false,
        title: '积分商城_商品详情 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/finance',
      name: 'finance',
      component: () => import('@/pages/Finance'),
      meta: {
        keepAlive: false,
        title: '供应链金融 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/accountEdit',
      name: 'accountEdit',
      component: () => import('@/pages/AccountEdit'),
      meta: {
        keepAlive: false,
        title: '账户中心 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/goodsList',
      name: 'goodsList',
      component: () => import('@/pages/GoodsList'),
      meta: {
        keepAlive: false,
        // title: '产品列表 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/GoodsCompared',
      name: 'goodsCompared',
      component: () => import('@/pages/GoodsCompared'),
      meta: {
        keepAlive: false,
        title: '积分商城 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: () => import('@/pages/OrderDetail'),
      meta: {
        keepAlive: false,
        title: '订单详情 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/goodsDetail',
      name: 'goodsDetail',
      component: () => import('@/pages/GoodsDetail'),
      meta: {
        keepAlive: false,
        // title: '产品详情 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/goodsSeo',
      name: 'goodsSeo',
      component: () => import('@/pages/GoodsSeoPage'),
      meta: {
        keepAlive: false,
        showHead: false,
        isMobile: false
      }
    },
    {
      path: '/payWay',
      name: 'payWay',
      component: () => import('@/pages/PayWay'),
      meta: {
        keepAlive: false,
        title: '支付 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: () => import('@/pages/PaySuccess'),
      meta: {
        keepAlive: false,
        title: '支付成功 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/orderRefund',
      name: 'orderRefund',
      component: () => import('@/pages/OrderRefund'),
      meta: {
        keepAlive: false,
        title: '申请退货 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/orderJudge',
      name: 'orderJudge',
      component: () => import('@/pages/OrderJudge'),
      meta: {
        keepAlive: false,
        title: '订单评价 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/goodsActivity',
      name: 'goodsActivity',
      component: () => import('@/pages/GoodsActivity'),
      meta: {
        keepAlive: false,
        title: '优惠促销 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/goodsActivityDetail',
      name: 'goodsActivityDetail',
      component: () => import('@/pages/GoodsActivityDetail'),
      meta: {
        keepAlive: false,
        title: '产品详情 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/goodsCar',
      name: 'goodsCar',
      component: () => import('@/pages/GoodsCar'),
      meta: {
        keepAlive: false,
        title: '购物车 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/confirmOrder',
      name: 'confirmOrder',
      component: () => import('@/pages/ConfirmOrder'),
      meta: {
        keepAlive: false,
        title: '确认订单 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/confirmOrderScore',
      name: 'confirmOrderScore',
      component: () => import('@/pages/ConfirmOrderScore'),
      meta: {
        keepAlive: false,
        title: '确认订单 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/payWayOffline',
      name: 'payWayOffline',
      component: () => import('@/pages/PayWayOffline'),
      meta: {
        keepAlive: false,
        title: '线下支付 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/payWayOfflineSure',
      name: 'payWayOfflineSure',
      component: () => import('@/pages/PayWayOfflineSure'),
      meta: {
        keepAlive: false,
        title: '线下支付 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/reapplyOrder',
      name: 'reapplyOrder',
      component: () => import('@/pages/ReapplyOrder'),
      meta: {
        keepAlive: false,
        title: '提货单重新申请提货 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/invoiceWrite',
      name: 'invoiceWrite',
      component: () => import('@/pages/InvoiceWrite'),
      meta: {
        keepAlive: false,
        title: '开票信息维护 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: () => import('@/pages/Withdraw'),
      meta: {
        keepAlive: false,
        title: '申请提现 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/topUp',
      name: 'topUp',
      component: () => import('@/pages/TopUp'),
      meta: {
        keepAlive: false,
        title: '充值 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/addBankCard',
      name: 'addBankCard',
      component: () => import('@/pages/AddBankCard'),
      meta: {
        keepAlive: false,
        title: '添加银行卡 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/modelContract',
      name: 'modelContract',
      component: () => import('@/pages/ModelContract'),
      meta: {
        keepAlive: false,
        title: '合同范本 - 畅为',
        showHead: true,
        isMobile: false
      },
    },
    {
      path: '/modelContractContent',
      name: 'modelContractContent',
      component: () => import('@/pages/ModelContractContent'),
      meta: {
        keepAlive: false,
        title: '合同范本 - 畅为',
        showHead: true,
        isMobile: false
      },
    },
    {
      path: '/contractContent',
      name: 'contractContent',
      component: () => import('@/pages/ContractContent'),
      meta: {
        keepAlive: false,
        title: '合同范本内容 - 畅为',
        showHead: true,
        isMobile: false
      },
    },
    {
      path: '/projectDetail',
      name: 'projectDetail',
      component: () => import('@/pages/ProjectDetail'),
      meta: {
        keepAlive: false,
        title: '项目详情 - 畅为',
        showHead: true,
        isMobile: false
      },
    },
    {
      path: '/modelProjectDetail',
      name: 'modelProjectDetail',
      component: () => import('@/pages/ModelProjectDetail'),
      meta: {
        keepAlive: false,
        title: '项目详情 - 畅为',
        showHead: true,
        isMobile: false
      },
    },
    {
      path: '/shelfDetail',
      name: 'shelfDetail',
      component: () => import('@/pages/ShelfDetail'),
      meta: {
        keepAlive: false,
        title: '上架详情 - 畅为',
        showHead: true,
        isMobile: false
      },
    },
    {
      path: '/ProjectAdd',
      name: 'ProjectAdd',
      component: () => import('@/pages/ProjectAdd'),
      meta: {
        keepAlive: false,
        title: '项目添加 - 畅为',
        showHead: true,
        isMobile: false
      },
    },
    {
      path: '/shelfAdd',
      name: 'shelfAdd',
      component: () => import('@/pages/ShelfAdd'),
      meta: {
        keepAlive: false,
        title: '上架添加 - 畅为',
        showHead: true,
        isMobile: false
      },
    },
    {
      path: '/discountCenter',
      name: 'discountCenter',
      component: () => import('@/pages/DiscountCenter'),
      meta: {
        keepAlive: false,
        title: '领券中心 - 畅为',
        showHead: true,
        isMobile: false
      },
    },
    {
      path: '/idea',
      name: 'idea',
      component: () => import('@/pages/Idea'),
      meta: {
        keepAlive: false,
        title: '意见反馈 - 畅为',
        showHead: true,
        isMobile: false
      },
    },
    {
      path: '/ideaList',
      name: 'ideaList',
      component: () => import('@/pages/IdeaList'),
      meta: {
        keepAlive: false,
        title: '反馈记录 - 畅为',
        showHead: true,
        isMobile: false
      },
    },
    {
      path: '/anniversary',
      name: 'anniversary',
      component: () => import('@/pages/Anniversary'),
      meta: {
        keepAlive: false,
        title: '周年庆活动 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/activity',
      name: 'activity',
      component: () => import('@/pages/Activity'),
      meta: {
        keepAlive: false,
        title: '周年庆活动 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/updatePwd',
      name: 'updatePwd',
      component: () => import('@/pages/UpdatePwd'),
      meta: {
        keepAlive: false,
        title: '修改密码 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/activityTemplate',
      name: 'activityTemplate',
      component: () => import('@/pages/ActivityTemplate'),
      meta: {
        keepAlive: false,
        title: '活动 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/solutionTemplate',
      name: 'solutionTemplate',
      component: () => import('@/pages/SolutionTemplate'),
      meta: {
        keepAlive: false,
        title: '解决方案 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/activityBrand',
      name: 'activityBrand',
      component: () => import('@/pages/ActivityBrand'),
      meta: {
        keepAlive: false,
        title: '汉盾首家入驻品牌赠送活动 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/activityRebate',
      name: 'activityRebate',
      component: () => import('@/pages/ActivityRebate'),
      meta: {
        keepAlive: false,
        title: '霍尼韦尔入驻畅为中台云 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/priceInquiry',
      name: 'priceInquiry',
      component: () => import('@/pages/PriceInquiry'),
      meta: {
        keepAlive: false,
        title: '采购询价 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/questionnaire',
      name: 'questionnaire',
      component: () => import('@/pages/Questionnaire'),
      meta: {
        keepAlive: false,
        title: '问卷调查 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/loginAuth',
      name: 'loginAuth',
      component: () => import('@/pages/LoginAuth'),
      meta: {
        keepAlive: false,
        title: '微信登录 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/bindwx',
      name: 'bindwx',
      component: () => import('@/pages/Bindwx'),
      meta: {
        keepAlive: false,
        title: '微信登录手机 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/gifts',
      name: 'gifts',
      component: () => import('@/pages/gifts'),
      meta: {
        keepAlive: false,
        title: '赠品活动 - 畅为',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/supplier',
      name: 'supplier',
      component: () => import('@/pages/Supplier'),
      meta: {
        keepAlive: false,
        title: '供应商申请',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/supplierLogin',
      name: 'supplierLogin',
      component: () => import('@/pages/SupplierLogin'),
      meta: {
        keepAlive: false,
        title: '供应商登录',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/applicationProgress',
      name: 'applicationProgress',
      component: () => import('@/pages/ApplicationProgress'),
      meta: {
        keepAlive: false,
        title: '供应商合作 -入驻进度查询',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/supplierForgot',
      name: 'supplierForgot',
      component: () => import('@/pages/SupplierForgot'),
      meta: {
        keepAlive: false,
        title: '供应商合作 - 忘记密码',
        showHead: true,
        isMobile: false
      }
    },
    {
      path: '/topicSolution',
      name: 'topicSolution',
      component:()=> import('@/pages/topicSolution'),
      meta:{
        keepAlive: false,
        title: '解决方案',
        showHead: true,
        isMobile: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js